var map = {
  "./accu.svg": "98635",
  "./arrow-long.svg": "92129",
  "./arrow.svg": "20918",
  "./calendar-new.svg": "78188",
  "./car.svg": "97023",
  "./charge.svg": "32471",
  "./check-new.svg": "14052",
  "./check.svg": "78289",
  "./chevron-down.svg": "60325",
  "./chevron-right.svg": "35517",
  "./clock.svg": "70715",
  "./close.svg": "73741",
  "./company.svg": "26568",
  "./cross.svg": "59237",
  "./dot.svg": "36284",
  "./email.svg": "81473",
  "./facebook.svg": "19655",
  "./flickr.svg": "58550",
  "./foursquare.svg": "17142",
  "./fullscreen.svg": "66092",
  "./google-plus.svg": "90983",
  "./info.svg": "15555",
  "./instagram.svg": "27341",
  "./linkedin.svg": "84033",
  "./magnifier.svg": "8193",
  "./mail.svg": "78518",
  "./map.svg": "47015",
  "./min.svg": "83113",
  "./minus.svg": "22153",
  "./nav-hamburger.svg": "16156",
  "./phone-2.svg": "8832",
  "./phone.svg": "98313",
  "./pinterest.svg": "84247",
  "./play.svg": "533",
  "./plug.svg": "91735",
  "./plus.svg": "46523",
  "./profile.svg": "86462",
  "./range.svg": "87418",
  "./snapchat.svg": "23357",
  "./speed.svg": "41900",
  "./star-bordered.svg": "26709",
  "./star-half-bordered.svg": "32729",
  "./star.svg": "39871",
  "./triangle-down.svg": "48776",
  "./triangle-right.svg": "19266",
  "./tumblr.svg": "99613",
  "./twitter.svg": "71120",
  "./usage.svg": "2260",
  "./user.svg": "92954",
  "./vimeo.svg": "44781",
  "./weight.svg": "74591",
  "./whatsapp.svg": "52417",
  "./wheel.svg": "16880",
  "./work.svg": "9708",
  "./wrench.svg": "10488",
  "./youtube.svg": "87942"
};


function __rspack_context(req) {
  var id = __rspack_context_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context.keys = function webpackContextKeys() {
  return Object.keys(map);
};
__rspack_context.resolve = __rspack_context_resolve;
module.exports = __rspack_context;
__rspack_context.id = 93310;
